import { Component, inject, Input } from '@angular/core';
import { BuildingSectionItemDto, TemplateService } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { currentTenantId } from '@/utils/admin-utils';

export interface TemplateSelectionDialogResult {
  templateId: string;
  buildingSectionIds: string[];
}

@Component({
  standalone: false,
  selector: 'wr-template-selection-dialog',
  templateUrl: './template-selection-dialog.component.html',
  styleUrls: ['./template-section-dialog.component.scss'],
})
export class TemplateSelectionDialogComponent {
  @Input()
  buildingSections!: BuildingSectionItemDto[];

  readonly templateService = inject(TemplateService);

  readonly tenantId = currentTenantId();

  readonly templates = asyncComputed(() => this.templateService.findAll({
    tenantId: this.tenantId()
  }));

  readonly toolTip = `
  Wenn Sie eine Vorlage importieren, werden alle Prüfpunkte,
  die einen Unterschied zu den bereits vorhandenen Prüfpunkten haben,
  als neue Prüfpunkte importiert.
  Prüfpunkte, die bereits vorhanden sind, werden nicht importiert.
`.trim();

  selectAll = false;
  selectedTemplateId = '';
  selectedBuildingSectionIds: string[] = [];
  onSubmit = () => ({
    templateId: this.selectedTemplateId,
    buildingSectionIds: this.selectedBuildingSectionIds,
  }) as TemplateSelectionDialogResult;

  onSectionCheckboxChange(sectionId: string, isChecked: boolean): void {
    if (isChecked) {
      if (!this.selectedBuildingSectionIds.includes(sectionId)) {
        this.selectedBuildingSectionIds.push(sectionId);
      }
    } else {
      this.selectedBuildingSectionIds = this.selectedBuildingSectionIds.filter(id => id !== sectionId);
    }
    this.selectAll = this.selectedBuildingSectionIds.length === this.buildingSections.length;
  }

  onSelectAllChange(isChecked: boolean): void {
    this.selectAll = isChecked;

    if (isChecked) {
      this.selectedBuildingSectionIds = this.buildingSections.map(section => section.id);
    } else {
      this.selectedBuildingSectionIds = [];
    }
  }

}
